export const defaultMonthlyPrice = 450;
export const defaultBudgetPrice = 25000;
export const CREDIT_VERIFICATION_TIMEOUT = 15000;
export const CREDIT_VERIFICATION_RESET_TIMEOUT = 10000;
export const ACTIVE_LISTINGS_COUNT_API = '/rest/lsc/listing/count';
export const landingPageValues = {
    used: 'usd',
    new: 'nw',
    certified: 'cert',
};
